module.exports = __webpack_public_path__ + "img/ddzc.477f8bcc.png";